const programs = [
  {
    id: 1,
    title: "びゅーちふるナイト！",
    image: "https://static.readdy.ai/image/f493cbe5c2084134677121347fdba237/7f1e13e6ee98d8421b0a7d4a5bafd98f.jpeg",
    description: "第1・3週目は桜チョメ吉さんがメインパーソナリティを担当。びゅーちふるずの素敵な歌と共に軽快なトークをお届け。皆さまからのおたよりも待ってます〜♪",
    schedule: "第1・3火曜 18:30〜",
    personality: "桜チョメ吉（びゅーちふるず）",
    media: "I&U-LaLa FM 83.0MHz",
    link: "https://windies-mania.net/WMS_Byu.html"
  },
  {
    id: 2,
    title: "このみさんに聴いてもらいたいマニアたち",
    image: "https://static.readdy.ai/image/f493cbe5c2084134677121347fdba237/9a9fdf762d50b51602886598d77a9c75.png",
    description: "第2・4週目はラジオの主（あるじ）がメインパーソナリティを担当。このみさんに聴いてもらいたい話があるんです！今宵も番組お抱えのマニアたちがラジオに集まって来るんです…",
    schedule: "第2・4火曜 18:30〜",
    personality: "ラジオの主人（あるじ）・このみ（役者/ダンサー）",
    media: "I&U-LaLa FM 83.0MHz",
    link: "https://windies-mania.net/KONOMI.html"
  }
];

export default function ProgramsSection() {
  return (
    <section id="programs" className="py-24 px-6 bg-gradient-to-b from-[#0a1628] to-[#0d1d35]">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-16">
          <h3 className="text-4xl md:text-5xl font-bold text-white mb-4">
            放送中の番組
          </h3>
          <div className="w-24 h-1 bg-[#ff1493] mx-auto rounded-full"></div>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {programs.map((program) => (
            <div
              key={program.id}
              className="group bg-white/5 backdrop-blur-sm rounded-2xl border border-white/10 overflow-hidden hover:border-[#ff1493]/50 transition-all duration-300 hover:transform hover:scale-[1.02]"
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={program.image}
                  alt={program.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0a1628] via-transparent to-transparent"></div>
              </div>
              
              <div className="p-6">
                <h4 className="text-xl font-bold text-white mb-3 group-hover:text-[#ff1493] transition-colors">
                  {program.title}
                </h4>
                
                <p className="text-white/70 text-sm mb-4 leading-relaxed line-clamp-3">
                  {program.description}
                </p>
                
                <div className="space-y-2">
                  <div className="flex items-center gap-2 text-sm">
                    <div className="w-6 h-6 flex items-center justify-center bg-[#ff1493]/20 rounded-full flex-shrink-0">
                      <i className="ri-calendar-line text-[#ff1493] text-xs"></i>
                    </div>
                    <span className="text-white/80">{program.schedule}</span>
                  </div>
                  
                  <div className="flex items-center gap-2 text-sm">
                    <div className="w-6 h-6 flex items-center justify-center bg-[#ffd700]/20 rounded-full flex-shrink-0">
                      <i className="ri-mic-line text-[#ffd700] text-xs"></i>
                    </div>
                    <span className="text-white/80 truncate">{program.personality}</span>
                  </div>
                  
                  <div className="flex items-center gap-2 text-sm">
                    <div className="w-6 h-6 flex items-center justify-center bg-[#00bfff]/20 rounded-full flex-shrink-0">
                      <i className="ri-radio-2-line text-[#00bfff] text-xs"></i>
                    </div>
                    <span className="text-white/80">{program.media}</span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
